// Global declaration for the window object
declare global {
  interface Window {
    __tcfapi: TcfApi;
  }
}

/** Interface for `window.__tcfapi` */
export interface TcfApi {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  (command: TcfApiCommandKeys, version: number, callback: (...params: any[]) => void, pFeature?: PermissionFeatures | string, pId?: number | number[]): void | never;
}

/** Supported `__tcfapi` commands */
export enum TcfApiCommands {
  'getTCData',
  'ping',
  'addEventListener',
  'removeEventListener',
  'updateTCString',
  'getTCString',
  'getACString',
  'getPermission',
  'getTCFVersion',
  'getTCLastUpdated',
  'getTCStringUtil',
  'getAppInfo'
}
export type TcfApiCommandKeys = keyof typeof TcfApiCommands; 

/** Human Readable Stacks */
export enum PermissionFeatures {
  'publisher',
  'purpose',
  'vendor',
  'special',
  'brainTracking',
  'uimservTracking',
  'agofTracking',
  'tgp',
  'oewaTracking',
  'googleAnalyticsTracking',
  'editorialPersonalization',
  'aditionAds',
  'siteSpectTesting',
  'fullConsent',
  'publisherCustomPurpose',
  'googleAc',
  'amazonAds',
  'specialGeoFeature',
  'googleAdsConversionTracking',
  'searchBasicAds',
  'searchPersonalisedAds',
  'sentryErrorTracing',
  'internalRetargeting',
  'googleBasicAds',
  'googleAdRemarketing',
  'vgwortTracking',
  'dpagSync',
  'appmonPerformanceTracing',
  'searchBasicAdsAmazon',
  'searchBasicAdsVerizon',
  'searchBasicAdsGoogle',
  'searchYahooImage',
  'firstPartyCookie',
  'thirdPartyCookie',
}
export type PermissionFeatureKeys = keyof typeof PermissionFeatures; 
